import { Dialog, DialogBackdrop, DialogTitle } from "@headlessui/react";
import React, { useEffect, useState } from "react";
import Select from "react-select";
import { IRosterConnectionCounts } from "../../../../model/interface/districts";
import { IReactSelect } from "../../../../model/interface/keyValuePair";

interface IConfirmDeleteRosterConnectionsProps {
  rosterConnectionCounts: Array<IRosterConnectionCounts>;
  onCancel: () => void;
  onConfirm: (externalRosterProviderId: number) => void;
}

export const ConfirmDeleteRosterConnections = (
  props: IConfirmDeleteRosterConnectionsProps
) => {
  const [externalRosterIds, setExternalRosterIds] = useState<Array<any>>([]);
  const [selectedExternalRosterId, setSelectedExternalRosterId] =
    useState<number>();
  const [confirmInput, setConfirmInput] = useState<string>();
  const [submitDisabled, setSubmitDisabled] = useState<boolean>(true);

  const CONFIRM_KEYWORD = "disconnect";

  const handleSelectedRosterProviderChange = (e) => {
    console.log(e);
    setSelectedExternalRosterId(e.value);
  };

  const handleConfirmInputChange = (event) => {
    setConfirmInput(event.target.value);
  };

  const handleConfirmClick = (event) => {
    if (!props.onConfirm) return;
    if (selectedExternalRosterId == null) return;

    props.onConfirm(selectedExternalRosterId);
  };

  const handleCancelClick = (event) => {
    if (!props.onCancel) return;

    props.onCancel();
  };

  useEffect(() => {
    const elements = props.rosterConnectionCounts
      .filter(
        (item) =>
          (item.externalRosterProviderId === 1 ||
            item.externalRosterProviderId === 2) &&
          (item.userCount > 0 || item.classCount > 0)
      )
      .map(
        (item, index) =>
          ({
            label: `${item.externalRosterProvider} (${item.userCount} users, ${item.classCount} classes)`,
            value: item.externalRosterProviderId,
          } as IReactSelect)
      );
    setExternalRosterIds(elements);
  }, []);

  useEffect(() => {
    setSubmitDisabled(
      selectedExternalRosterId == null || confirmInput !== CONFIRM_KEYWORD
    );
  }, [confirmInput, selectedExternalRosterId]);

  return (
    <div>
      <Dialog
        as="div"
        className="fixed z-10 inset-0"
        onClose={() => false}
        open={true}
      >
        <div className="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
          <DialogBackdrop className="fixed inset-0 bg-gray-500 bg-opacity-75 transition-opacity" />

          {/* This element is to trick the browser into centering the modal contents. */}
          <span
            className="hidden sm:inline-block sm:align-middle sm:h-screen"
            aria-hidden="true"
          >
            &#8203;
          </span>
          <div className="inline-block align-bottom bg-white rounded-lg px-4 pt-5 pb-4 text-left  shadow-xl transform transition-all sm:my-8 sm:align-middle sm:p-6 w-1/4">
            <div className="hidden sm:block absolute top-0 right-0 pt-4 pr-4"></div>
            <div className="sm:flex sm:items-start">
              <div className="w-full mt-3 text-center sm:mt-0 sm:text-left">
                <DialogTitle as="h3" className="text-sm text-gray-700">
                  Disconnect all district users and classes from roster provider
                </DialogTitle>
                <br />
                <span className={"text-red-900 font-bold"}>Warning:</span> This
                will remove all the links to the roster provider you have chosen
                for all this districts users and classes. The users and classes
                will still exist but will no longer be tied to the selected
                roster provider.
                <br />
                <br />
                Users will be unable to log in via SSO after the process is
                complete and should only be used if they are de-integrating
                entirely or changing sync services.
                <div className="w-full mt-4">
                  <Select
                    id="rosterProvider"
                    className={`mt-1 block border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary-color focus:border-primary-color sm:text-sm w-full`}
                    placeholder="Select the Roster Provider"
                    options={externalRosterIds}
                    onChange={handleSelectedRosterProviderChange}
                  />
                </div>
                <div className="w-full mt-4">
                  <input
                    id="confirmKeyword"
                    type="text"
                    onChange={handleConfirmInputChange}
                    placeholder={`Type the word "${CONFIRM_KEYWORD}" to confirm`}
                    defaultValue=""
                    className={`mt-1 block border border-gray-300 rounded-md shadow-sm focus:outline-none focus:ring-primary-color focus:border-primary-color sm:text-sm w-full`}
                  />
                </div>
              </div>
            </div>
            <div className="mt-5 sm:mt-4 sm:flex sm:flex-row-reverse">
              <button
                disabled={submitDisabled}
                type="button"
                className={`${
                  submitDisabled ? "bg-gray-100" : "bg-primary-color"
                } w-full inline-flex justify-center rounded-md border border-transparent shadow-sm px-4 py-2 text-base font-medium text-white sm:ml-3 sm:w-auto sm:text-sm`}
                onClick={handleConfirmClick}
              >
                Disconnect
              </button>
              <button
                type="button"
                className="mt-3 w-full inline-flex justify-center rounded-md border border-gray-300 shadow-sm px-4 py-2 bg-white text-base font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-primary-color sm:mt-0 sm:w-auto sm:text-sm"
                onClick={handleCancelClick}
              >
                Cancel
              </button>
            </div>
          </div>
        </div>
      </Dialog>
    </div>
  );
};
